import React from 'react';
import * as _ from 'lodash';

/**
 * 60分間表記の時間用セレクトボックス ( 00 〜 59分まで )
 * @props {string}className:セレクトタグのclassName属性
 * @props {string}name:セレクトタグのname属性
 * @props {string}value:変化させたいステートのパラメーター
 * @props {function}onChange:セレクトボックスのデータを選択した時の処理
 */
export class SelectMin extends React.Component {
  constructor(props) {
    super(props);
    if (
      this.props.onChange !== undefined &&
      typeof this.props.onChange === 'function'
    ) {
      this.onChange = this.props.onChange.bind(this);
    } else {
      console.warn('onChange is not function');
    }
  }

  // 画面表示
  render() {
    return (
      <select
        className={this.props.className}
        name={this.props.name}
        value={this.props.value}
        onChange={this.onChange}
      >
        {_.map(new Array(60), (v, index) => {
          const val = zeroPadding(index);
          return (
            <option key={index} value={index}>
              {val}
            </option>
          );
        })}
      </select>
    );
  }
}

const zeroPadding = number => {
  return `0${number}`.slice(-2);
};



// WEBPACK FOOTER //
// ./src/components/select/SelectMin.jsx